import React, { useRef } from 'react';
import { motion, useMotionValue, useSpring, useTransform } from 'framer-motion';
type TiltProps = {
  children: React.ReactNode;
  className?: string;
  max?: number;
};
/** Subtle perspective tilt that follows the mouse. Inert on touch devices. */
export function Tilt({
  children,
  className = '',
  max = 5
}: TiltProps) {
  const ref = useRef<HTMLDivElement>(null);
  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  const rotateX = useSpring(useTransform(my, [-0.5, 0.5], [max, -max]), {
    stiffness: 150,
    damping: 20
  });
  const rotateY = useSpring(useTransform(mx, [-0.5, 0.5], [-max, max]), {
    stiffness: 150,
    damping: 20
  });
  const handleMove = (e: React.MouseEvent<HTMLDivElement>) => {
    if (typeof window !== 'undefined' && window.matchMedia('(pointer: coarse)').matches) return;
    const rect = ref.current?.getBoundingClientRect();
    if (!rect) return;
    mx.set((e.clientX - rect.left) / rect.width - 0.5);
    my.set((e.clientY - rect.top) / rect.height - 0.5);
  };
  const reset = () => {
    mx.set(0);
    my.set(0);
  };
  return <div className={className} style={{
    perspective: 1000
  }} onMouseMove={handleMove} onMouseLeave={reset} data-id="element-379">
      <motion.div ref={ref} style={{
      rotateX,
      rotateY,
      transformStyle: 'preserve-3d'
    }} data-id="element-380">
        {children}
      </motion.div>
    </div>;
}